const demoDataSet = [
  {
    label: null,
    backgroundColor: 'rgba(230, 162, 60, 0.1)',
    data: [0, 18, 5, 8, 8, 4, 16, 18, 5, 1, 5, 2, 10, 12, 14, 0],
    lineTension: 0,
    borderWidth: 4,
    borderColor: 'rgba(230, 162, 60, 0.9)',
    pointRadius: 0,
    pointHitRadius: 25,
  },
]

const demoLabels = [
  '',
  'May 02, 2024',
  'May 03, 2024',
  'May 04, 2024',
  'May 05, 2024',
  'May 06, 2024',
  'May 07, 2024',
  'May 08, 2024',
  'May 09, 2024',
  'May 10, 2024',
  'May 11, 2024',
  'May 12, 2024',
  'May 13, 2024',
  'May 14, 2024',
  'May 15, 2024',
  'May 16, 2024']

export { demoDataSet, demoLabels }
